<template>
  <div class="invite-error">
    <LargeNotice
      v-if="error && (error.type === 'TOKEN_ALREADY_USED' || error.type === 'TOKEN_EXPIRED')"
      v-on:click="contactUs"
      v-on:second-button-click="redirectToLogin"
      icon="😢"
      :title="this.$t('error.title')"
      :subtitle="this.$t('error.invite-expired-token')"
      :buttonText="$t('page.keywords.contact')"
      :buttonIcon="'arrow-right'"
      :secondButtonText="$t('invite.go-to-login')"
    />
    <LargeNotice
      v-else
      v-on:click="contactUs"
      v-on:second-button-click="redirectToLogin"
      icon="⚠️"
      :title="this.$t('error.title')"
      :subtitle="this.$t('error.invite-error')"
      :buttonText="$t('page.keywords.contact')"
      :buttonIcon="'arrow-right'"
      :secondButtonText="$t('invite.go-to-login')"
    />
  </div>
</template>

<script>
import LargeNotice from '@/components/notice/LargeNotice';
import { paths } from '@/util/paths';
import { Beacon } from '@/plugins/beacon';

export default {
  components: {
    LargeNotice,
  },
  props: {
    error: Object,
  },
  methods: {
    contactUs() {
      this.$track.contactUs('invite');
      Beacon.toggle();
      Beacon.navigate('ask');
    },
    redirectToLogin() {
      this.$router.push(paths.login);
    },
  },
};
</script>

<style lang="scss"></style>
